import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryTaskSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <g clipPath="url(#clip0_6149_102954)">
          <path
            d="M21.4997 14.5003H17.5997C17.5479 14.4967 17.499 14.4745 17.4622 14.4378C17.4255 14.401 17.4033 14.3521 17.3997 14.3003V10.5003C17.4144 10.308 17.389 10.1147 17.3252 9.93276C17.2614 9.75079 17.1605 9.58404 17.0289 9.44306C16.8973 9.30209 16.7379 9.18994 16.5608 9.11372C16.3836 9.0375 16.1926 8.99886 15.9997 9.00025C15.8018 8.99659 15.6051 9.03288 15.4214 9.10697C15.2378 9.18105 15.071 9.29141 14.9309 9.43143C14.7909 9.57146 14.6805 9.73828 14.6065 9.92192C14.5324 10.1056 14.4961 10.3023 14.4997 10.5003V14.4003C14.4962 14.4521 14.474 14.501 14.4373 14.5378C14.4005 14.5745 14.3516 14.5967 14.2997 14.6003H10.4997C10.3057 14.577 10.109 14.5964 9.92322 14.6571C9.73748 14.7178 9.56723 14.8183 9.42438 14.9516C9.28152 15.085 9.16951 15.2479 9.09616 15.429C9.02282 15.6101 8.98991 15.8051 8.99975 16.0003C9.00939 16.395 9.17052 16.771 9.44976 17.0502C9.729 17.3295 10.105 17.4906 10.4997 17.5003H14.3997C14.4516 17.5038 14.5005 17.526 14.5373 17.5627C14.574 17.5995 14.5962 17.6484 14.5997 17.7003V21.6003C14.5949 21.7854 14.6279 21.9696 14.6965 22.1416C14.7652 22.3137 14.8681 22.4699 14.9991 22.6009C15.1301 22.7319 15.2863 22.8348 15.4583 22.9035C15.6304 22.9721 15.8146 23.0051 15.9997 23.0003C16.3945 22.9906 16.7705 22.8295 17.0497 22.5502C17.329 22.271 17.4901 21.895 17.4997 21.5003V17.6003C17.5033 17.5484 17.5255 17.4995 17.5622 17.4627C17.599 17.426 17.6479 17.4038 17.6997 17.4003H21.5997C21.9686 17.3926 22.3203 17.2426 22.5812 16.9817C22.8421 16.7208 22.9921 16.3692 22.9997 16.0003C23.0161 15.7991 22.9885 15.5969 22.9188 15.4075C22.8492 15.2181 22.7393 15.0461 22.5966 14.9034C22.4539 14.7607 22.2819 14.6508 22.0925 14.5812C21.9031 14.5115 21.7009 14.4839 21.4997 14.5003Z"
            fill="#2B303B"
          />
        </g>
        <defs>
          <clipPath id="clip0_6149_102954">
            <rect width="14" height="14" fill="white" transform="translate(9 9)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default TaskHistoryTaskSVG;
